import React, { useState, useEffect } from 'react';
import './ChatBox.css'; // Make sure to create this CSS file
import { useSpeechSynthesis } from "react-speech-kit";


function ChatFAQ() {
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [pitch, setPitch] = useState(1);
    const [rate, setRate] = useState(1);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    //const [token, setToken] = useState('y4334789308ejksdjljw9832a121wq55re');
    const [token, setToken] = useState('HGDTDDRFJASGBSA132131212');

    const onEnd = () => {
    }
    const { speak, cancel, speaking, voices } = useSpeechSynthesis({onEnd})
    const voice = voices[5];
/*
    useEffect(() => {
        const obtenerUbicacion = async () => {
          const ubicacion = await obtenerUbicacionPorIP();
          console.log('Después de obtenerUbicacionPorIP:', ubicacion.longitude, ubicacion.latitude);
        };
        obtenerUbicacion();
        console.log(longitude);
        console.log(latitude);
      }, []);
*/
      const obtenerUbicacionPorIP = async () => {
        try {
          const response = await fetch('https://ipapi.co/json/', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });
          const responseJson = await response.json();
          setLatitude(responseJson.latitude);
          setLongitude(responseJson.longitude);
          console.log('Dentro de obtenerUbicacionPorIP:', responseJson.longitude, responseJson.latitude);
          return responseJson;
        } catch (error) {
          setLongitude(0.0);
          setLatitude(0.0);
          console.error('Error al obtener la ubicación por IP:', error);
          throw error;
        }
      };


    const handleQuestionChange = (event) => {
        setQuestion(event.target.value);
    };

    const revisar = () => {
        voices.map((option, index) => {
            console.log(option.lang + ' - ' + option.name);
            console.log(index);
        });
    }

    const handleSubmit_ANT = async () => {
      if (!question) return;
      setIsLoading(true);
      try {
          const requestBody = {
            coleccion: "FAQJSONCollection",
            tipoembeddings: "Openai",
            openaimodelo: "text-embedding-3-small",
            tipometrica: "L2",
            dim: 1536,
            pregunta: question,
          };
          const response = await fetch('https://insurtechsoft.com:8097/openai/askgpt/LBCFAQ/', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'TOKEN': token
              },
              body: JSON.stringify(requestBody),
          });
          if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log(data);
          setAnswer(data);
      } catch (error) {
          console.error("There was an error!", error);
      }
      //setQuestion(''); // Clear the question field
      setIsLoading(false);
  };


    const handleSubmit = async () => {
        if (!question) return;
        setIsLoading(true);
        try {
            const requestBody = {
              pregunta: question,
              respuesta: ""
            };
            //const response = await fetch('https://insurtechsoft.com:8097/openai/askgpt/LBCFAQ/', {
            const response = await fetch('https://desarrollo.lbc.bo/LBC/Aplicaciones/GPT4LBC/api/Faq', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'KEY_GPT4LBC': 'HGDTDDRFJASGBSA132131212'
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                console.error(response);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setAnswer(data.respuesta);
        } catch (error) {
            console.error("There was an error!", error);
        }
        //setQuestion(''); // Clear the question field
        setIsLoading(false);
    };

    const limpiarCampos = () => {
        setQuestion(''); 
        setAnswer('');  
    }
    return (
        <div className="chatbox-container">
            <input
                className="chatbox-input"
                type="text"
                value={question}
                onChange={handleQuestionChange}
                placeholder="Escribe tu FAQ"
            />
            <button
                className={`chatbox-button ${isLoading ? "loading" : ""}`}
                onClick={handleSubmit}
                disabled={isLoading}
            >
                {isLoading ? "Enviando..." : "Enviar"}
            </button>
            <div className="chatbox-answer">{answer}
                {/*answer && answer.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))*/}
            </div>

            <div className="contenedorBoton" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              {speaking ? (
                <button class="btn btn-primary" type="button" onClick={cancel}
                  style={{ backgroundColor: '#DFDFDF', border: 'none', color: 'red', padding: '10px 22px', textAlign: 'center', textDecoration: 'none', display: 'inline-block', fontSize: '12px', margin: '4px 2px', cursor: 'pointer', borderRadius: '8px' }}>
                  Parar
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => speak({ text: answer, voice, rate, pitch })}
                  style={{ backgroundColor: '#AABBCC', border: 'none', color: 'blue', padding: '10px 22px', textAlign: 'center', textDecoration: 'none', display: 'inline-block', fontSize: '12px', margin: '4px 2px', cursor: 'pointer', borderRadius: '8px' }}>
                  Escuchar
                </button>
              )}
              <button
                  style={{
                    backgroundColor: '#DFDFDF',
                    border: 'none',
                    color: 'blue',
                    padding: '10px 22px',
                    textAlign: 'center',
                    textDecoration: 'none',
                    display: 'inline-block',
                    fontSize: '12px',
                    margin: '4px 2px',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    width: '95px'
                  }}
                    onClick={limpiarCampos}
              >
                Limpiar
              </button>
            </div>
        </div>
    );
}

export default ChatFAQ;
